export enum ComponentType {
  Component = 'Component',
  Equipment = 'Equipment',
  Material = 'Material',
  PPE = 'PPE',
  SpecialTestEquipment = 'Special Test Equipment',
  SpecialTooling = 'Special Tooling',
  SubComponent = 'Sub Component',
}
